import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { t } from "ttag";

import ErrorIcon from "merchant-portal-icons/ErrorIcon";

import { MessageBox, MessageBoxSize, MessageType } from "./MessageBox";

export interface ErrorBoxProps {
	title?: string;
	message: MessageType;
	handleRetry?: () => void;
	retryMessage?: string;
	icon?: JSX.Element;
	testId?: string;
}

export const ErrorBox: React.FC<ErrorBoxProps> = ({
	title = t`Oops...`,
	message,
	handleRetry,
	retryMessage,
	icon = <ErrorIcon />,
	testId = "error-message-box",
}) => (
	<Box
		data-testid={testId}
		sx={{
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			width: "50rem",
		}}
	>
		<MessageBox title={title} size={MessageBoxSize.Large} message={message} icon={icon} />
		{typeof handleRetry === "function" && (
			<Button
				color="primary"
				variant="text"
				data-testid="error-retry-button"
				onClick={() => handleRetry()}
			>
				{retryMessage || t`Try Again`}
			</Button>
		)}
	</Box>
);
